import { getSystem } from './util.js'
const system = getSystem()
const instances = []
export default function install(Vue) {
  Vue.directive('tap', { bind, unbind })
}
function isAvailable(modifiers) {
  return modifiers.all || modifiers.press || system === 'ios'
}
function bind(node, directive) {
  const modifiers = directive.modifiers
  if (isAvailable(modifiers)) {
    instances.push(new Tap(node, modifiers))
  }
}
function unbind(node, directive) {
  const modifiers = directive.modifiers
  if (isAvailable(modifiers)) {
    instances.forEach((tap, index) => {
      if (tap.node === node) {
        tap.handler(false)
        instances.splice(index, 1)
      }
    })
  }
}
export class Tap {
  constructor(node, modifiers) {
    this.start = (e) => {
      this.stop(e)
      this.moved = false
      if (this.triggerPress) {
        this.pressTimer = window.setTimeout(() => {
          if (!this.moved) {
            this.pressTriggered = true
            this.trigger('press')
          }
        }, Tap.pressTime)
      }
      this.coord = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
      }
    }
    this.move = (e) => {
      this.stop(e)
      this.moved =
        this.moved ||
        Math.max(
          Math.abs(e.touches[0].clientX - this.coord.x),
          Math.abs(e.touches[0].clientY - this.coord.y)
        ) > Tap.tapMove
    }
    this.end = (e) => {
      this.stop(e)
      e.cancelable && e.preventDefault && e.preventDefault()
      if (this.pressTriggered) {
        this.pressTriggered = false
      } else {
        if (this.triggerPress) {
          window.clearTimeout(this.pressTimer)
        }
        if (!this.moved) {
          this.trigger('click')
        }
      }
    }
    this.node = node
    this.triggerPress = modifiers.press
    this.stopPropagation = modifiers.stop
    this.handler(true)
  }
  handler(flag) {
    const action = flag ? 'addEventListener' : 'removeEventListener'
    this.node[action]('touchstart', this.start)
    this.node[action]('touchmove', this.move)
    this.node[action]('touchend', this.end)
    this.node[action]('touchcancel', this.end)
  }
  stop(e) {
    if (e && e.stopPropagation && this.stopPropagation) {
      e.stopPropagation()
    }
  }
  trigger(eventName) {
    let event
    if ('CustomEvent' in window) {
      event = new CustomEvent(eventName)
    } else {
      event = document.createEvent('CustomEvent')
      event.initCustomEvent(eventName, true, true, void 0)
    }
    this.node.dispatchEvent(event)
  }
}
Tap.tapMove = 8
Tap.pressTime = 500
